export var META_KEY = "#META";
export var KEY_ORIGINAL_METHOD = "original-method";
export var KEY_BEFORE_METHOD = "before-method";
export var KEY_AFTER_METHOD = "after-method";
export var KEY_BEFORE_INSTANCE = "before-instance";
export var KEY_AFTER_INSTANCE = "after-instance";
export var KEY_METHOD_EXCEPTION = "method-exception";
//# sourceMappingURL=constants.js.map